const BLUE_LOGO_FILTER = "invert(19%) sepia(93%) saturate(3146%) hue-rotate(226deg) brightness(88%) contrast(96%)";

export default function Logo({ size = "md", variant = "blue", className = "" }) {
  const sizes = {
    sm: "h-6",
    md: "h-8",
    lg: "h-12",
  };

  if (variant === "black" || variant === "blue" || variant === "white") {
    return (
      <img
        src={`/landing/min-logo-${variant === "blue" ? "black" : variant}.png`}
        alt="Min"
        className={`${sizes[size]} w-auto object-contain ${className}`}
        width={variant === "white" ? 548 : 1200}
        height={variant === "white" ? 326 : 712}
        style={variant === "blue" ? { filter: BLUE_LOGO_FILTER } : undefined}
      />
    );
  }

  return (
    <span className={`inline-flex items-center font-display font-bold ${size === "sm" ? "text-lg" : size === "lg" ? "text-4xl" : "text-2xl"} tracking-tight ${className}`}>
      <span className="text-primary leading-none">Min</span>
    </span>
  );
}
